// Logos des connecteurs et des fournisseurs (portails, boîtes, banques, abonnements), tirés des
// icônes publiées par chaque fournisseur et rangés dans src/logos : Vite les sert hachés sous /assets, donc gardés hors
// ligne. Une clé sans logo prend l'initiale de son nom, sur la même tuile claire (une icône
// noire reste lisible en thème sombre).

import { cleLogoDeNom } from './marques'

const FICHIERS = import.meta.glob<string>('../logos/*.png', {
  eager: true,
  query: '?url',
  import: 'default',
})

const LOGOS: Readonly<Record<string, string>> = Object.fromEntries(
  Object.entries(FICHIERS).map(([chemin, url]) => [chemin.replace(/^.*\/|\.png$/g, ''), url]),
)

/** La clé du logo d'une banque, d'après le nom que donne l'agrégateur. */
export const logoDeBanque = cleLogoDeNom

export function Logo({
  cle,
  nom,
  taille = 28,
}: {
  cle: string | null
  nom: string
  taille?: number
}) {
  const url = cle ? LOGOS[cle] : undefined
  return (
    <span
      className={`logo-tuile${url ? '' : ' logo-initiale'}`}
      style={{ width: taille, height: taille }}
      aria-hidden="true"
    >
      {url ? (
        <img
          src={url}
          alt=""
          width={Math.round(taille * 0.72)}
          height={Math.round(taille * 0.72)}
        />
      ) : (
        (nom.trim()[0] ?? '?').toUpperCase()
      )}
    </span>
  )
}

/** Le logo d'un fournisseur d'après son nom, son initiale s'il n'en a pas. */
export function LogoDe({ nom, taille }: { nom: string; taille?: number }) {
  return <Logo cle={cleLogoDeNom(nom)} nom={nom} {...(taille !== undefined && { taille })} />
}

/** Le logo seulement s'il est connu : pour un libellé de relevé, dont l'initiale ne dit rien. */
export function LogoConnu({ nom, taille }: { nom: string | null | undefined; taille?: number }) {
  const cle = cleLogoDeNom(nom)
  if (!cle || !nom) return null
  return <Logo cle={cle} nom={nom} {...(taille !== undefined && { taille })} />
}
